import { useMemo } from 'react';
import dayjs from 'dayjs';

const MONTH_MAP = {
  JAN: '01',
  FEB: '02',
  MAR: '03',
  APR: '04',
  MAY: '05',
  JUN: '06',
  JUL: '07',
  AUG: '08',
  SEP: '09',
  OCT: '10',
  NOV: '11',
  DEC: '12',
};

export const useCollectionDateParse = (messageId: string | undefined) => {
  return useMemo(() => {
    if (!messageId) return { startDate: '', endDate: '' };

    try {
      const year = messageId.substring(0, 4);
      const month = messageId.substring(4, 7);
      const day = messageId.substring(7, 9);
      const time = messageId.substring(10, 14);

      const monthNum = MONTH_MAP[month];
      if (monthNum) {
        const startDate = dayjs(`${year}-${monthNum}-${day}`);
        const endDate = startDate.add(3, 'day');

        const formatDate = (date: dayjs.Dayjs) => {
          const year = date.format('YYYY');
          const month = date.format('MM');
          const day = date.format('DD');
          const hour = time.substring(0, 2);
          const minute = time.substring(2, 4);
          return `${year}-${month}-${day} ${hour}:${minute}`;
        };

        return {
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
        };
      }
    } catch (error) {
      console.error('Error parsing collection date:', error);
    }

    return { startDate: '', endDate: '' };
  }, [messageId]);
};
